module.exports = __webpack_public_path__ + "img/forward.2a65f29a.svg";